import React from 'react';
import TabContainer from '../../components/TabContainer';
import ReceteListePage from '../recipe/ReceteListePage';
import MaliyetAnalizPage from '../recipe/MaliyetAnalizPage';
import TransferFiyatPage from '../recipe/TransferFiyatPage';
import FoodCostDashboard from '../recipe/FoodCostDashboard';
import FireDenetimiPage from '../recipe/FireDenetimiPage';
import MarkaAtanmamisPage from '../recipe/MarkaAtanmamisPage';
import IcSatisFiyatEksikPage from '../recipe/IcSatisFiyatEksikPage';

const ReceteMaliyetPage = () => {
  const tabs = [
    { id: 'recete-listesi', label: 'Reçeteler', icon: '📋', component: <ReceteListePage /> },
    { id: 'maliyet-analizi', label: 'Maliyet Analizi', icon: '💰', component: <MaliyetAnalizPage /> },
    { id: 'transfer-fiyat', label: 'Transfer Fiyatları', icon: '🏷️', component: <TransferFiyatPage /> },
    { id: 'food-cost', label: 'Food Cost', icon: '📊', component: <FoodCostDashboard /> },
    { id: 'fire-denetimi', label: 'Fire Denetimi', icon: '🔥', component: <FireDenetimiPage /> },
    { id: 'marka-atanmamis', label: 'Marka Atanmamış', icon: '🏢', component: <MarkaAtanmamisPage /> },
    { id: 'ic-satis-eksik', label: 'İç Fiyatı Eksik', icon: '💸', component: <IcSatisFiyatEksikPage /> },
  ];
  return <TabContainer title="Reçete & Maliyet" tabs={tabs} defaultTab="recete-listesi" />;
};

export default ReceteMaliyetPage;
